let module = {
  /**
   * 数字格式化
   * @param {String} num 数字字符串
   * @param {Number} scale 小数位数，默认为2
   * @param {String} extra 附加内容
   * @param {Boolean} sign 是否显示正负符号
   * @param {Number} mult 放大倍数，默认不放大
   */
  decimal: function (num, scale = 2, extra = '', sign, mult = 1) {
    var f = parseFloat(num)
    if (isNaN(f)) return '--'
    f = f * mult
    var _sign = sign && f >= 0 ? '+' : ''
    return _sign + (scale >= 0 ? f.toFixed(scale) : f) + extra
  },
  decimal2: function (x, num) { // 解析浮点数，返回小数点后两位
    return this.decimal(x, num);
  },
  rate: function (x, num) { // 解析浮点数，返回小数点后两位
    num = num || 2;
    var f = parseFloat(x);
    if (isNaN(f)) {
      return "--"
    } else {
      x = parseFloat(x) * 100;
      return x.toFixed(num);
    }
  },
  decimal4: function (x) { // 解析浮点数，返回小数点后四位
    return this.decimal(x, 4);
  },
  mul: function (arg1, arg2) { // 高精度浮点数乘法
    var m = 0,
      s1 = arg1.toString(),
      s2 = arg2.toString();
    if (s1.split(".").length == 2) {
      m += s1.split(".")[1].length;
    }
    if (s2.split(".").length == 2) {
      m += s2.split(".")[1].length;
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  },
  div: function(num1, num2) { // 高精度浮点数除法
    var _getPointPow = (num1, num2) => { //获取两个数小数点的长度最大值，然后取10的次幂
      if(typeof num2!=='number') {
        throw new TypeError('数字不合法');
      }
      var pointLength1=0;
      var pointLength2=0;
      //如果存在小数点
      if((num1+'').indexOf('.') > -1){
        pointLength1=(num1+'').split('.')[1].length;
        
      }
      if((num2+'').indexOf('.') > -1){
        pointLength2=(num2+'').split('.')[1].length;
      }
      return Math.pow(10,Math.max(pointLength1,pointLength2));
    }
    var pow = _getPointPow(num1,num2);
    return ((num1*pow)/(num2*pow))
  },
  add: function (num1, num2) { // 高精度浮点数加法
    var r1, r2, m;
    try {
      r1 = num1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = num2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return Math.round(num1 * m + num2 * m) / m;
  },
  sub: function (num1, num2) { // 高精度浮点数减法
    var r1, r2, m;
    try {
      r1 = num1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = num2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    return Math.round(num1 * m - num2 * m) / m;
  }
}
export default module;


// WEBPACK FOOTER //
// ./src/assets/utils/float-fmt.js